












































export default function (Component) {
  Component.options.__source = "src/module/components/lolth-explorer/renderer/cmp-list-item-count-cell-renderer.vue"
}
